let replaceURLWithHTMLLinks = (content, color) => {
	// 在HTML转义后的文本中匹配URL: 遇空白/引号/尖括号才终止,
	// 允许 ()'* 及 &amp; 实体等字符出现在链接中, 避免链接被截断
	const urlRegex = /((?:https?|ftp|file):\/\/|www\.)[^\s<>"]+/gi;
	return content.replace(urlRegex, (url) => {
	    // 剥离尾部吞入的中英文句末标点/收括号/引号
	    url = url.replace(/[.,;:!?。，；：！？）)】\]」』']+$/, '');
	    // 如果URL不以http(s)://开头，则添加http://前缀
	    if (!url.startsWith("http")) {
	        url = "http://" + url;
	    }
	    return `<a href="${url}" target="_blank" rel="noopener" style="color: ${color};text-decoration: underline;">${url}</a>`;
	});
}

export default {
	replaceURLWithHTMLLinks
}